/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invalid_RefundInputs */

const vi_error_invalid_refund = /** @type {(inputs: Error_Invalid_RefundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lựa chọn hoàn tiền chưa đúng: chọn hình thức hoàn, số tiền lớn hơn 0 và phương thức tiền mặt hoặc chuyển khoản.`)
};

/**

* @param {Error_Invalid_RefundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_invalid_refund = /** @type {((inputs?: Error_Invalid_RefundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invalid_RefundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_invalid_refund(inputs)
});